import SelectFilter from "@components/common/SelectFilter.jsx";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import useFilterData from "@hooks/useFilterData.js";
import { FLAGS } from "../../../config/growthbook/flags.js";

function DistributorsFilter({
	value,
	onChange,
	businessUnitId = null,
	params = {},
	enabled = true,
}) {
	const typeEnabled = useFeatureIsOn(FLAGS.shared.distributorsFilter.typeFilterEnabled);
	const { data, isLoading, hasMore, searchTerm, loadMore, setSearchTerm } = useFilterData({
		endpoint: "/api/companies",
		enabled,
		queryParams: {
			businessUnits: [businessUnitId],
			type: typeEnabled ? 1 : null,
			...params,
		},
	});

	return (
		<SelectFilter
			id="distributor-filter"
			dataTestId="distributor-filter"
			label="Filter by"
			placeholder="Distributor"
			value={value}
			onChange={onChange}
			options={data}
			isLoading={isLoading}
			hasMore={hasMore}
			onLoadMore={loadMore}
			searchTerm={searchTerm}
			onSearchChange={setSearchTerm}
			optionLabel="name"
			optionValue="id"
			showSearch={true}
			searchPlaceholder="Search by distributor"
		/>
	);
}

export default DistributorsFilter;
